

export class PoiDetailsStatusInput implements IPoiDetailsStatusInput {
    /** The auto-generated id of the poi details master */
    poiDetailsId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IPoiDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiDetailsId = _data["poiDetailsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiDetailsId"] = this.poiDetailsId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiDetailsStatusInput {
    /** The auto-generated id of the poi details master */
    poiDetailsId: number;
    /** The updated status */
    status: number;
}

